import { render, staticRenderFns } from "./Visual.vue?vue&type=template&id=2456fa10&scoped=true"
import script from "./Visual.vue?vue&type=script&lang=js"
export * from "./Visual.vue?vue&type=script&lang=js"
import style0 from "./Visual.vue?vue&type=style&index=0&id=2456fa10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2456fa10",
  null
  
)

export default component.exports